import React, { Fragment } from 'react'
import { useLandingLayout, LandingLayoutProps } from './useLandingLayout'
import Header from './Header/Header'
import Footer from './Footer/Footer'

const LandingLayout: React.FC<LandingLayoutProps> = (
  props: LandingLayoutProps
) => {
  const { children } = useLandingLayout(props)

  return (
    <Fragment>
      <Header />
      {children}
      <Footer />
    </Fragment>
  )
}

export default LandingLayout
